export default __webpack_public_path__ + "static/pull_station_w.2da486c9528c8f5140a0553785e30d6c.png";